"use strict";
import { theme } from "../../ThemeContext/ThemeObject";
export const styles = {
  candidatesPageContainer: {
    backgroundColor: theme.palette.common.white,
    padding: "40px",
    rowGap: 4
  },
  candidatesPageHeader: {
    fontWeight: "bold",
    fontSize: "38px",
    color: "#666666"
  },
  filterActive: {
    color: "red"
  },
  filterInactive: {
    color: "grey"
  },
  fadedFull: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    transition: "opacity 0.3s ease-in-out"
  },
  animationLottie: {
    width: "45px",
    height: "45px"
  },
  felixDescription: {
    position: "relative",
    height: "45px",
    width: "calc(100% - 50px)",
    top: 0
  },
  progressWrapper: {
    marginTop: "4px",
    width: "100%",
    padding: "5px",
    borderRadius: "10px",
    backgroundColor: "#D8E3FF"
  },
  progressBar: {
    padding: "5px",
    borderRadius: "5px",
    backgroundColor: "transparent",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "#7A8EF1"
    }
  },
  autocomplete: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
      backgroundColor: "#FFFFFF",
      color: "#333333",
      border: "1px solid #DDDDDD",
      fontSize: "18px",
      padding: "0 10px 0 10px !important",
      height: "42px",
      width: "80%",
      fontFamily: "Source Sans Pro, sans-serif",
      textTransform: "capitalize",
      "&:focus": {
        borderColor: "#2D388D"
      }
    },
    "& .MuiOutlineInput-root:focus": {
      backgroundColor: "#ffffff",
      borderRadius: "6px"
    },
    "& fieldset": {
      display: "none"
    },
    "& .MuiAutocomplete-popupIndicator": {
      color: "#AAAAAA",
      marginRight: "10px",
      transition: "all 0.16s ease-in-out"
    }
  }
};
